module.exports = __webpack_public_path__ + "img/violet_046.d6aa038b.png";